var _rect, _rect2, _g, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2694_200)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2694_200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 50
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2694_200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.352 29.6903L13.7277 32.6321H7.84608L11.352 29.6903ZM10.605 28.7816L6.00415 32.6411L6.00226 23.149L10.605 28.7816ZM21.6751 19.2235C21.6751 19.2235 20.6651 18.7454 19.4917 18.8152C18.1502 18.8942 17.028 19.4087 16.3828 20.0875C15.9769 20.514 15.5281 21.0342 15.3026 21.5992C14.9757 22.4166 14.9059 23.4966 14.9059 23.4966C14.9059 23.4966 14.4368 23.0984 13.849 21.9381C13.1655 20.5885 12.9785 19.7709 12.8859 18.8382C12.8035 18.0198 12.9329 17.2104 12.9329 17.2104H21.6751V19.2235ZM21.6751 21.9145V27.8996C21.6751 27.8996 21.1316 28.1083 20.6883 28.1083C20.245 28.1083 19.49 28.0426 18.6132 27.5606C17.7428 27.0824 17.261 26.504 16.8875 25.9798C16.5087 25.4466 16.1959 24.7075 16.1029 24.1749C16.0282 23.7488 15.9476 22.686 16.3828 21.8222C16.619 21.3534 17.2529 20.5499 18.4732 20.5042C19.4679 20.466 20.0195 20.7276 20.5251 21.005C21.4872 21.5341 21.6751 21.9145 21.6751 21.9145ZM12.1559 27.4793L13.7327 26.1649C13.2302 25.523 13.0974 25.2811 12.5356 24.4523C11.9604 23.6041 11.4786 22.6708 11.0666 21.5758C10.6207 20.3897 10.513 19.7237 10.5622 18.8382C10.6239 17.7116 10.8801 17.2104 10.8801 17.2104H6L6.00226 19.8406C6.00226 19.8406 9.73781 24.522 12.1559 27.4793ZM16.6615 32.6278H21.6751V28.9721C21.6751 28.9721 20.4315 29.5426 19.6232 29.5886C19.142 29.6167 18.6749 29.6352 17.9212 29.4347C17.0835 29.2121 16.6075 28.9952 15.831 28.3547C15.2074 27.841 14.4943 27.0824 14.4943 27.0824L12.9082 28.4049C13.6441 29.305 14.1876 29.9602 14.354 30.1366C15.0693 30.8925 15.3724 31.1704 15.8542 31.4398C16.3359 31.7097 17.945 31.6951 17.945 31.6951L16.6615 32.6278Z",
    fill: "#E94E0F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5927 29.3761C59.5927 30.4353 59.7355 32.1764 58.5493 32.6002V32.6708H63.0545V32.6002C61.8691 32.1532 62.0113 30.4353 62.0113 29.3761V20.5048C62.0113 19.4461 61.8691 17.7046 63.0545 17.2576V17.187H58.5493V17.2576C59.7587 17.7046 59.5927 19.4225 59.5927 20.5048V29.3761ZM43.0729 20.5048L51.2063 30.7412C52.2493 32.0822 52.9849 32.8591 54.6683 33.4236V20.2224C54.6683 18.9049 54.6683 17.9634 55.9017 17.2576V17.187H51.7279V17.2576C52.9849 17.9634 52.9607 18.9049 52.9607 20.2224V29.141L44.2825 18.2693L43.9501 17.7986C43.7845 17.6105 43.6898 17.4929 43.5949 17.2106V17.187H40.1323V17.2576C41.3655 17.9634 41.3655 18.9049 41.3655 20.2224V29.612C41.3655 30.9294 41.3655 31.8705 40.1091 32.6002V32.6708H44.3063V32.6002C43.0493 31.8705 43.0729 30.9294 43.0729 29.612V20.5048ZM29.8151 23.423V18.8109L31.4035 18.6458C32.8265 18.5046 34.3437 19.3519 34.3437 20.9758C34.3437 22.9054 32.1385 23.423 30.5976 23.423H29.8151ZM29.8151 30.7882V24.9757L31.4746 24.8817C33.5614 24.764 35.7903 25.7526 35.7903 28.0351C35.7903 30.2706 33.8227 31.1647 31.8778 30.9766L29.8151 30.7882ZM27.3961 29.3527C27.3961 30.4353 27.5385 32.1532 26.3525 32.6002V32.6708H30.2652C32.0436 32.6708 33.9174 32.7416 35.5769 31.9414C37.1657 31.1883 38.4226 29.635 38.4226 27.823C38.4226 25.5173 36.6912 24.1052 34.5571 23.6578C35.9089 23.0697 36.9282 22.1756 36.9282 20.5989C36.9282 18.5046 35.1028 17.187 31.973 17.187H26.3525V17.2576C27.5625 17.7046 27.3961 19.4225 27.3961 20.4812V29.3527Z",
    fill: "#005B6A"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 49,
    rx: 2.5,
    stroke: "#E6E7E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2694_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBni);
export default __webpack_public_path__ + "static/media/bni.f1aa63e098ccabb5ce9b798bf6f2610e.svg";
export { ForwardRef as ReactComponent };